import { ChangeDetectorRef, Component } from '@angular/core';

import { TellentBrand } from '@tellent/types';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { WindowRef } from '@recruitee/user-interface';

import { environment } from '../environments/environment';
import { AccountSetupBundles } from './account-setup-bundles.service';

/* eslint-disable @angular-eslint/prefer-standalone */
@Component({
  selector: 'rto-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
})
export class AppComponent {
  public loading: boolean = true;
  public isTellentSetup = this.windowRef.nativeWindow.location.hostname.includes(
    TellentBrand.Tellent,
  );

  private ngOnDestroy$ = new Subject<void>();

  constructor(
    protected cdRef: ChangeDetectorRef,
    private accountSetupBundles: AccountSetupBundles,
    private windowRef: WindowRef,
  ) {}

  public ngOnInit(): void {
    if (this.isTellentSetup) this.useTellentFavicon();

    if (environment.analytics) {
      this.loadGrowsumo();
    } else {
      // TODO remove after testing
      (<any>window).loadGrowsumo = this.loadGrowsumo.bind(this);
    }
  }

  private loadGrowsumo(): void {
    const growsumoBundle = this.accountSetupBundles.create({
      name: 'growsumo',
      url: 'https://snippet.growsumo.com/growsumo.min.js',
    });

    growsumoBundle
      .load()
      .pipe(
        filter(status => status.loaded),
        takeUntil(this.ngOnDestroy$.asObservable()),
      )
      .subscribe(() => {
        const growsumo = (<any>window).growsumo;
        growsumo._initialize(environment.growsumoPublicKey);
      });
  }

  private useTellentFavicon(): void {
    const faviconLink: HTMLLinkElement | null = document.querySelector('link[rel="icon"]');
    if (faviconLink) faviconLink.href = 'assets/favicon-tellent.ico';
  }
}
